import React, { useEffect, useState } from 'react';
import Moment from 'moment-timezone';
import { extendMoment } from 'moment-range';
import { useDispatch } from 'react-redux';
import { setToast } from '../../store/ToastManagement';
import {
  Container,
  Grid,
  Segment,
  Image,
  Dropdown,
  Button,
  Modal,
  Header
} from 'semantic-ui-react';
import { useCurrentUser } from '../../_services/hooks';
import {
  servicesAPI,
  useCustomer,
  useCustomerBillingAccount,
  // useLance,
  useLanceToCustomers,
  useMeter,
  useCustomerVehicles,
  useReferenceVehicles,
  useVehicleData
} from '../../_services';
import { history } from '../../_helpers';
import { isAON } from '../../utils';
import './customerDetail_styles.css';

const moment = extendMoment(Moment);

export const ChargingSession = () => {
  const { currentUser, currentUserIsCustomer, customerId } = useCurrentUser();
  const { customer } = useCustomer(customerId);
  const account = useCustomerBillingAccount(customerId);
  const { customerVehicles } = useCustomerVehicles(customerId);
  const referenceVehicles = useReferenceVehicles();
  const [selectedCustomerVehicle, setSelectedCustomerVehicle] = useState(0);
  const [selectedVehicleType, setSelectedVehicleType] = useState(null);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const vehicleData = useVehicleData(selectedVehicleType);

  if (currentUser) {
    // Ensure they've signed the T&Cs
    // if (customer && customer.agreed_to_terms_datetime === '') {
    //   document.location.href = '/customer/terms';
    // }
  }

  // Non-AON customers cannot charge without card details
  useEffect(() => {
    if (
      customer &&
      account &&
      !isAON(customer) &&
      account.card_last4_digits === ''
    )
      setIsPaymentModalOpen(true);
  }, [customer, account]);

  useEffect(() => {
    if (
      customerVehicles &&
      customerVehicles.length &&
      referenceVehicles.length
    ) {
      const cvs = customerVehicles.filter(
        cv => cv.id === selectedCustomerVehicle
      );
      if (cvs.length === 1) {
        setSelectedVehicleType(cvs[0].vehicle_id);
      }
    }
  }, [selectedCustomerVehicle, customerVehicles, referenceVehicles]);

  const vehicleOptions = customerVehicles
    ? customerVehicles
        .map((v, idx) => {
          let text = v.registration_no;
          if (referenceVehicles) {
            const rvs = referenceVehicles.filter(rv => rv.id === v.vehicle_id);
            if (rvs.length === 1) {
              text = `${v.registration_no} ${rvs[0].make} ${rvs[0].model}`;
            }
          }
          return {
            text: text,
            value: v.id
          };
        })
        .concat([
          {
            text: 'Unknown EV',
            value: 0
          }
        ])
    : [
        {
          text: 'Unknown EV',
          value: 0
        }
      ];

  function useAsyncHook(id, phalanxId) {
    const [session, setSession] = React.useState(null);
    const [phalanx, setPhalanx] = React.useState(null);

    useEffect(() => {
      async function getSession(id) {
        try {
          const session = await servicesAPI.MeteringServices(
            'getSessionByLanceToCustomer',
            id
          );
          setSession(session);

          const sessionlet = await servicesAPI.MeteringServices(
            'getLatestSessionlet',
            session.id
          );

          const tariff = await servicesAPI.BillingServices(
            'getTariff',
            sessionlet.tariff_id
          );

          // AON tariffs vary and the exact price isn't stored in the sessionlet
          if (!isAON(customer)) setTariff(tariff);
        } catch (error) {}
      }

      if (id) getSession(id);
    }, [id]);

    useEffect(() => {
      async function getPhalanx(phalanxId) {
        try {
          const response = await servicesAPI.InventoryServices(
            'getPhalanx',
            phalanxId
          );
          setPhalanx(response);
        } catch (error) {}
      }

      if (phalanxId) getPhalanx(phalanxId);
    }, [phalanxId]);

    return [session, phalanx];
  }

  const setChargingVehicle = customer_vehicle_id => {
    setSelectedCustomerVehicle(customer_vehicle_id);

    const values = { vehicle_id: customer_vehicle_id };
    servicesAPI
      .MeteringServices('updateSessionVehicle', values, session.id)
      .then(
        response => {},
        error => {}
      );
  };

  useEffect(() => {
    // Default to first vehicle
    if (customerVehicles && customerVehicles.length)
      setSelectedCustomerVehicle(customerVehicles[0].id);
  }, [customerVehicles]);

  const lanceToCustomers = useLanceToCustomers(customerId);

  // TDTODO Choosing first Lance but customer may have multiple Lances
  const lanceTagId = lanceToCustomers.length
    ? lanceToCustomers[0].lance_tag_id
    : null;
  // const lance = useLance(lanceTagId);

  const [apcActive, setApcActive] = React.useState(false);
  const [needAPCDecision, setNeedAPCDecision] = React.useState(-1);
  const [lanceToCustomerId, setLanceToCustomerId] = React.useState(null);
  const [phalanxTagId, setPhalanxTagId] = React.useState(null);
  const [session, phalanx] = useAsyncHook(lanceToCustomerId, phalanxTagId);
  const [tariff, setTariff] = React.useState(null);
  const meter = useMeter(phalanx ? phalanx.meter_tag_id : null);
  const location = meter ? meter.charging_location : null;

  const [time, setTime] = useState(Date.now()); // eslint-disable-line

  useEffect(() => {
    const interval = setInterval(() => {
      if (lanceToCustomerId) {
        setLanceToCustomerId(null);
      } else {
        // TDTODO Choosing first Lance but customer may have multiple Lances
        setLanceToCustomerId(
          lanceToCustomers.length ? lanceToCustomers[0].id : null
        );
      }
      if (phalanxTagId) {
        setPhalanxTagId(null);
      } else {
        setPhalanxTagId(session ? session.phalanx_tag_id : null);
      }
      return setTime(Date.now());
    }, 3000);
    return () => {
      clearInterval(interval);
    };
  }, [lanceToCustomers, lanceToCustomerId]); // eslint-disable-line

  let status =
    session && session.status !== 'ENDED' ? session.status : 'NO_SESSION';

  useEffect(() => {
    if (phalanx && phalanx.apc_limit !== null) {
      setApcActive(phalanx.apc_limit < 100);
      // inventory.phalanx.boost: 0=no boost, 1=boost, -1=undefined
      // needAPCDecision: 0=no, 1=yes, -1=TBC
      if (
        phalanx.apc_limit < 100 &&
        phalanx.boost === -1 &&
        needAPCDecision === -1
      )
        setNeedAPCDecision(1);
    }
  }, [session, phalanx]); // eslint-disable-line

  const dispatch = useDispatch();
  const displaySuccess = message =>
    dispatch(setToast({ title: 'Success!', body: message }));

  if (!currentUser) {
    return <div>Loading...</div>;
  }
  if (!currentUserIsCustomer) {
    history.push(`/404`);
  }

  let chargingLocation = location ? location.toUpperCase() : '';
  let chargingDurationHrs = '';
  let chargingTotalKWh = '';
  let chargingMilesAdded = '';
  let chargingRateKW = '';
  let pricePerKwh = '';
  let buttonText = '';
  let buttonImage = '';

  let overrideChargeRate = -1;

  if (status === 'NO_SESSION') {
    chargingLocation = '';
    chargingDurationHrs = '-';
    chargingTotalKWh = '-';
    chargingMilesAdded = '-';
    chargingRateKW = '-';
    pricePerKwh = '-';

    buttonText = 'PLEASE INSERT YOUR LANCE';
    buttonImage = '/images/no_lance_present.png';
  } else {
    const sessionStart = moment(session.timestamp, 'YYYY-MM-DDTHH:mm:ss,Z');
    const now = moment.utc();
    const sessionDuration = moment.duration(now.diff(sessionStart));

    const hours = sessionDuration.hours();
    const mins =
      (sessionDuration.minutes() < 10 ? '0' : '') + sessionDuration.minutes();
    // const secs =
    //   (sessionDuration.seconds() < 10 ? '0' : '') + sessionDuration.seconds();
    chargingDurationHrs = `${hours}:${mins}`;

    chargingTotalKWh = session
      ? `${(session.total_consumption / 1000).toFixed(2)}`
      : '-';

    // From Mark Constable "Use 3.3 mi/kWh - any car-based figure will exclude the 8-15% charging
    // losses. 3.3 is a decent average taken at the meter, and equates to 3.8-3.9 at the car."
    const efficiency = vehicleData ? vehicleData.efficiency : 1000.0 / 3.3;
    chargingMilesAdded = session
      ? `≈${(session.total_consumption / efficiency).toFixed(1)}`
      : '-';

    // Calculate average charge rate. If we have analytics, use last 5 minutes
    let chargeRate = session ? session.charge_rate : 0;
    if (session?.analytics?.prev5minutes) {
      const numPhases = session?.analytics?.num_phases
        ? session?.analytics?.num_phases
        : 1;
      const meanCurrent = session?.analytics?.prev5minutes?.mean
        ? session?.analytics?.prev5minutes?.mean
        : 0;
      chargeRate =
        numPhases === 1
          ? (230 * meanCurrent) / 1000
          : (400 * Math.sqrt(3) * meanCurrent) / 1000;
    }

    chargingRateKW = chargeRate.toFixed(0);

    pricePerKwh = tariff ? `${tariff.cost}p` : '-';

    // Charging paused?
    // if (lance && lance.override_charge_rate === 0 && chargingRateKW < 1)
    //   status = 'PAUSED';

    // TDTODO chargingHeading = 'NO CURRENT CHARGE SESSION';

    if (status === 'STARTED') {
      buttonText = '';
      buttonImage = '/images/charging.png';
      overrideChargeRate = 0;
    } else if (status === 'PAUSED') {
      buttonText = '';
      buttonImage = '/images/ready_to_charge.png';
      overrideChargeRate = 1;
    }
  }

  const buttonClick = () => {
    // Can't pause/resume when no session active
    if (!lanceTagId || overrideChargeRate === -1) return;

    // Temporarily disable pause/resume button
    // const values = {
    //   override_charge_rate: overrideChargeRate
    // };
    // servicesAPI.InventoryServices('updateLance', values, lanceTagId).then(
    //   response => {},
    //   error => {}
    // );
  };

  const acceptApcClick = () => {
    if (!session) return;

    const values = {
      boost: 0
    };
    servicesAPI
      .InventoryServices('updatePhalanxByReference', values, phalanx.reference)
      .then(
        response => {
          setNeedAPCDecision(0);
          displaySuccess('Controlled Charge limit accepted');
        },
        error => {}
      );
  };

  const overrideApcClick = () => {
    if (!session) return;
    const values = {
      boost: 1
    };
    servicesAPI
      .InventoryServices('updatePhalanxByReference', values, phalanx.reference)
      .then(
        response => {
          setNeedAPCDecision(0);
          displaySuccess('BOOST override applied');
        },
        error => {}
      );
  };

  const closeModal = event => {
    event.preventDefault();
    event.stopPropagation();
    setIsPaymentModalOpen(false);
  };

  return (
    <div>
      <Container>
        <Grid centered padded>
          <Grid.Column style={{ maxWidth: 500 }}>
            <div
              style={{
                marginBottom: '0px',
                minHeight: '660px',
                paddingLeft: '0px',
                paddingRight: '0px',
                paddingBottom: '0px'
              }}
            >
              <Segment>
                {(!apcActive || needAPCDecision !== 1) && (
                  <Grid
                    centered
                    padded
                    textAlign="center"
                    verticalAlign="middle"
                  >
                    <Grid.Row />
                    <Grid.Row>
                      <b>YOUR CURRENT CHARGE SESSION</b>
                    </Grid.Row>
                    {status !== 'NO_SESSION' && (
                      <Grid.Row>
                        <Dropdown
                          selection
                          search
                          options={vehicleOptions}
                          onChange={(_, { value }) => {
                            setChargingVehicle(value);
                          }}
                          value={selectedCustomerVehicle}
                        />
                      </Grid.Row>
                    )}
                    <Grid.Row>{chargingLocation}</Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={8} textAlign="center">
                        <div className="stat-box">
                          <Image
                            className="stat-image"
                            src={'/images/duration.png'}
                          />
                          <p className="stat-text">
                            {chargingDurationHrs}
                            <br />
                            hrs
                          </p>
                        </div>
                        <p className="stat-name">DURATION</p>
                      </Grid.Column>
                      <Grid.Column width={8} textAlign="center">
                        <div className="stat-box">
                          <Image
                            className="stat-image"
                            src={'/images/total_charge.png'}
                          />
                          <p className="stat-text">
                            {chargingTotalKWh}
                            <br />
                            kWh
                          </p>
                        </div>
                        <p className="stat-name">TOTAL CHARGED</p>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={8} textAlign="center">
                        <div className="stat-box">
                          <Image
                            className="stat-image"
                            src={'/images/miles_added.png'}
                          />
                          <p className="stat-text">
                            {chargingMilesAdded}
                            <br />
                            mi
                          </p>
                        </div>
                        <p className="stat-name">MILES ADDED</p>
                      </Grid.Column>
                      <Grid.Column width={8} textAlign="center">
                        <div className="stat-box">
                          <Image
                            className="stat-image"
                            src={'/images/current_rate.png'}
                          />
                          <p
                            className={!apcActive ? 'stat-text' : 'stat-text-r'}
                          >
                            {chargingRateKW}
                            <br />
                            kW
                          </p>
                          <p className="stat-text-small">@ {pricePerKwh}/kWh</p>
                        </div>
                        <p className="stat-name">CURRENT RATE</p>
                      </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                      <Grid.Column width={16} textAlign="center">
                        <div onClick={buttonClick}>
                          <Image src={buttonImage} />
                          {buttonText}
                        </div>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                )}
                {apcActive && needAPCDecision === 1 && (
                  <Grid
                    centered
                    padded
                    textAlign="center"
                    verticalAlign="middle"
                  >
                    <Grid.Row>
                      <b>
                        CONTROLLED CHARGE LIMIT BEING
                        <br />
                        APPLIED TO PROTECT THE GRID -
                        <br />
                        CHARGING MAY BE SLOWER THAN USUAL
                      </b>
                    </Grid.Row>
                    <Grid.Row>
                      ESTIMATED TIME OF LIMITED
                      <br />
                      CHARGING RATE: 30 MINS
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={16} textAlign="center">
                        <Button
                          className="apc-box"
                          color="olive"
                          onClick={acceptApcClick}
                        >
                          <p className="apc-box-text">
                            CONTINUE WITH CONTROLLED CHARGE LIMIT AND HELP
                            PROTECT THE GRID
                          </p>
                        </Button>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={16} textAlign="center">
                        <Button
                          className="apc-box"
                          color="green"
                          onClick={overrideApcClick}
                        >
                          <p className="apc-box-text">
                            OVERRIDE CONTROLLED CHARGE
                            <br />
                            LIMIT AND BOOST ME
                          </p>
                        </Button>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                )}
              </Segment>
            </div>
          </Grid.Column>
        </Grid>
        <Modal
          open={isPaymentModalOpen}
          size="mini"
          style={{ padding: '20px' }}
        >
          <Modal.Content>
            <Header as="h2" textAlign="left">
              No Payment Details
            </Header>
            <p>
              Please register card payment details before charging your vehicle.
              Thank you.
            </p>
            <Button color="olive" onClick={closeModal}>
              OK
            </Button>
          </Modal.Content>
        </Modal>
      </Container>
    </div>
  );
};
